if (!customElements.get("product-recommendations")) {
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
      this.abortController = null;
      this.observer = new IntersectionObserver(
        (entries) => {
          if (!entries[0]?.isIntersecting) return;

          this.observer.disconnect();
          this.loadRecommendations();
        },
        { rootMargin: "0px 0px 400px 0px" },
      );
    }

    connectedCallback() {
      if (this.dataset.recommendationsPerformed === "true") {
        return;
      }

      if (!this.dataset.productId || !this.dataset.sectionId || !this.dataset.url) {
        return;
      }

      if (this.dataset.hideUntilLoaded === "true") {
        this.loadRecommendations();
        return;
      }

      this.observer.observe(this);
    }

    disconnectedCallback() {
      this.observer.disconnect();
      this.abortController?.abort();
    }

    async loadRecommendations() {
      const url = new URL(this.dataset.url, window.location.origin);
      url.searchParams.set("product_id", this.dataset.productId);
      url.searchParams.set("section_id", this.dataset.sectionId);
      url.searchParams.set("intent", this.dataset.intent || "related");

      this.abortController?.abort();
      this.abortController = new AbortController();

      try {
        const response = await fetch(url.toString(), { signal: this.abortController.signal });

        if (!response.ok) {
          this.hide();
          return;
        }

        const html = await response.text();
        const documentFragment = new DOMParser().parseFromString(html, "text/html");
        const replacement = documentFragment.getElementById(this.id);

        if (!replacement) {
          this.hide();
          return;
        }

        this.replaceWith(replacement);
      } catch (error) {
        if (error.name !== "AbortError") {
          this.hide();
        }
      } finally {
        this.abortController = null;
      }
    }

    hide() {
      this.classList.add("hidden");
    }
  }

  customElements.define("product-recommendations", ProductRecommendations);
}
